import { SafeHtml } from '@/Components/shared/SafeHtml';
import { NEWS_BODY_CLASSNAME } from './newsBodyStyles';

/**
 * Corps d'une nouveauté, assaini à l'affichage. Les images, les vidéos
 * téléversées et les vidéos YouTube passent ; toute autre `iframe` est retirée
 * (cf. `SafeHtml`).
 *
 * À utiliser partout où un corps de nouveauté est rendu (page, modale, aperçu) :
 * ne pas injecter `bodyHtml` autrement.
 */
export function NewsBody({ html, className = '' }: { html: string | null | undefined; className?: string }) {
  return (
    <SafeHtml
      html={html}
      allowImages
      allowVideos
      allowYoutubeEmbeds
      className={`${NEWS_BODY_CLASSNAME} ${className}`}
    />
  );
}
